//https://gqlazprthlxp.greenlinknetworks.com/

export const parameters = {
  DOMAIN_A: "gqlazprthlxp",
  DOMAIN_B: "azpqmwmlpi",

  // Commission rate
  COMMISSION_DOMAIN_A: "20",
  COMMISSION_DOMAIN_B: "25",
};

export const AGREEMENT_PAGE = "AGREEMENT";
export const COMMITMENT_PAGE = "COMMITMENT";
export const SUCCESS_PAGE = "SUCCESS_PAGE";
export const AGREEMENT_PDF = "AGREEMENT_PDF";
export const COMMITMENT_PDF = "COMMITMENT_PDF";



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/assets/js/constants.js